import React from 'react';

interface IProps {
  width?: string;
  height?: string;
}

const TelegramIcon: React.FC<IProps> = ({ width = '31', height = '26' }) => (
  <svg
    width={width}
    height={height}
    className={`h-[${height}px] w-[${width}px]`}
    viewBox="0 0 31 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.18734 11.4531C10.2404 7.94447 15.6103 5.63139 18.2972 4.51383C25.9688 1.32296 27.5629 0.768675 28.6019 0.750177C28.8304 0.746347 29.3413 0.80298 29.6723 1.07154C29.9518 1.29831 30.0287 1.60464 30.0655 1.81964C30.1023 2.03464 30.1481 2.52442 30.1117 2.90712C29.6959 7.27518 27.8971 17.8753 26.982 22.7676C26.5947 24.8377 25.8323 25.5318 25.0941 25.5997C23.4899 25.7474 22.2717 24.5396 20.718 23.5211C18.2867 21.9273 16.9132 20.9352 14.5532 19.38C11.8258 17.5827 13.5938 16.5949 15.1482 14.9805C15.5549 14.558 22.6231 8.12899 22.7599 7.54578C22.777 7.47284 22.7929 7.20095 22.6313 7.05738C22.4698 6.91382 22.2314 6.96291 22.0594 7.00196C21.8155 7.0573 17.9315 9.6245 10.4073 14.7036C9.30483 15.4606 8.30624 15.8295 7.41155 15.8101C6.42522 15.7888 4.52791 15.2524 3.11746 14.794C1.38749 14.2316 0.0125406 13.9343 0.132268 12.9793C0.194629 12.4818 0.879654 11.9731 2.18734 11.4531Z"
      fill="currentColor"
    />
  </svg>
);

export default TelegramIcon;
